<template>
  <div class="product-information-page">
    <div class="nav-page-box">
      <nav-page-view
        :tabHoverPage="1"
      ></nav-page-view>
    </div>
    <div class="product-banner">
      <img :src="productInformationBannerImage" alt="">
      <div>
        <banner-page-view
          :titleObj="productBannerObj"
        ></banner-page-view>
      </div>
    </div>
    <div class="product-center-box">
      <div class="product-center flex-middle-x layout-flex-justify-content_space-between">
        <div class="product-content flex-middle-x layout-flex-justify-content_space-between">
          <img :src="productCenterTitleImage" alt="">
          <div>
            <h4>定制化服务</h4>
            <p>“斗票网”是全国首家真正电影比价购票平台，与猫眼网，淘票票、网票网、
              卖座网等电影票务平台实时数据对接，覆盖全国10000家以上影院，
              是目前首家真正实现在线比价、购票、观影全流程业务的平台，且产品支持全面定制化开发。</p>
            <p>“约车吧”是一款聚合打车平台，实现多平台一键叫车、在线比价等功能，目前已与首约汽车、滴滴出行、
              享道出行等国内一线出行平台合作，覆盖全国80%城市，
              旨在为用户提供最佳出行方式、最具性价比的打车方式。</p>
          </div>
        </div>
        <div>
          <img :src="productCenterImage" alt="">
        </div>
      </div>
    </div>
    <div class="part-of-the-case">
      <title-page-view
        :titleObj="partOfTheCaseObj"
      ></title-page-view>
    </div>
    <div class="part-of-the-case-banner">
      <multi-line-distribution-wiper
      :bannerList="bannerList"
      :bannerSlidesPerView="bannerSlidesPerView"
      :bannerSlidesPerColumn="bannerSlidesPerColumn"
      @actionClickBanner="actionClickBanner"
      >
      </multi-line-distribution-wiper>
    </div>
    <div class="footer-page-box">
      <footer-page-view
      ></footer-page-view>
    </div>
  </div>
</template>
<script>
  import MultiLineDistributionSwiper from '@/components/computer/product/MultiLineDistributionSwiper'
  export default {
    name:'',
    data(){
      return {
        bannerSlidesPerView:3,
        bannerSlidesPerColumn:2,
        productInformationBannerImage: require('./image/product-information-banner-image.jpg'),
        productBannerObj:{
          mainHeading:'产品信息',
          subhead:'力致打造行业领导者',
          content:'Shanghai golden guarantee network technology co. LTD'
        },
        partOfTheCaseObj:{
          mainHeading:'Part of the case',
          subhead:'部 分 案 例 ',
          content:'“按需求定制最优框架，提供简单易用操作体验，交付满意服务成果”'
        },
        productCenterTitleImage:require('./image/product-center-title-image.png'),
        productCenterImage:require('./image/product-center-image.png')
      }
    },
    components:{
      'multi-line-distribution-wiper':MultiLineDistributionSwiper
    },
    computed:{
      bannerList(){
        return [
          {imgUrl:require('./image/icbc.png'), content:'中国工商银行- 影票系统'},
          {imgUrl:require('./image/zgyh.png'), content:'中国银行- 影票系统'},
          {imgUrl:require('./image/abc.png'), content:'中国农业银行- 影票系统'},
          {imgUrl:require('./image/abc-js.png'), content:'中国农业银行(江苏分行)- 影票系统'},
          {imgUrl:require('./image/jsyh.png'), content:'中国建设银行- 影票系统'},
          {imgUrl:require('./image/jtyh.png'), content:'交通银行- 影票系统'},
          {imgUrl:require('./image/bjyh.png'), content:'北京银行- 影票系统'},
          {imgUrl:require('./image/gdyh.png'), content:'光大银行- 影票系统'},
          {imgUrl:require('./image/gfyh.png'), content:'广发银行- 影票系统'},
          {imgUrl:require('./image/hxyh.png'), content:'华夏银行- 影票系统'},
          {imgUrl:require('./image/mdb.png'), content:'买单吧- 影票系统'},
          {imgUrl:require('./image/msyh.png'), content:'中国民生银行- 影票系统'},
          {imgUrl:require('./image/payh.png'), content:'平安银行- 影票系统'},
          {imgUrl:require('./image/pfyh.png'), content:'浦发银行- 影票系统'},
          {imgUrl:require('./image/shyh.png'), content:'上海银行- 影票系统'},
          {imgUrl:require('./image/xyyh.png'), content:'兴业银行- 影票系统'}
        ]
      }
    },
    methods:{
      actionClickBanner(index){
        console.log(index);
      }
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">
  .product-information-page{
    width:100%;
    min-width:1200px;
    .nav-page-box{
      width:100%;
    }
    .product-banner{
      width:100%;
      min-width:1200px;
      position: relative;
      height:450px;
      overflow: hidden;
      img{
        width:100%;
        min-height:450px;
      }
      div{
        width:600px;
        position: absolute;
        top:50%;left:50%;
        transform: translate(-50%, -50%);
      }
    }
    .product-center-box{
      width:100%;
      background: $color-4;
      padding-top:40px;
      .product-center{
        max-width:1200px;
        margin:auto;
        .product-content{
          img{
            width:80px;
          }
          div{
            text-align: left;
            margin-left:40px;
            h4{
              font-size:20px;
              color:$color-black;
            }
            p{
              font-size:16px;
              color:$color-3;
              margin-top:10px;
              text-align: justify;
            }
          }
        }
        img{
          width:500px;
        }
      }
    }
    .part-of-the-case-banner{
      max-width:1240px;
      margin:30px auto;
    }
    .footer-page-box{
      width:100%;
    }
  }
</style>
